import React, { useState, useEffect } from 'react';
import InputList from './InputList';

const IL_CandidateResponsibilities = ({
  questionnaireCriteria,
  onCriteriaChange,
  label = "Candidate Responsibilities",
  placeholder = "Enter a responsibility...",
  emptyMessage = "No candidate responsibilities added yet"
}) => {

  // Extract candidate responsibilities from questionnaire criteria
  const getInitialResponsibilities = () => {
    if (questionnaireCriteria?.candidateResponsibilities?.items) {
      return questionnaireCriteria.candidateResponsibilities.items.map(item => ({
        title: item.responsibility,
        subtitle: item.rationale || ''
      }));
    }
    return [];
  };

  // State for candidate responsibilities
  const [responsibilities, setResponsibilities] = useState(getInitialResponsibilities());

  // Update responsibilities when questionnaireCriteria changes
  useEffect(() => {
    setResponsibilities(getInitialResponsibilities());
  }, [questionnaireCriteria]);

  // Update candidate responsibilities criteria JSON
  const updateCandidateResponsibilitiesCriteria = (newResponsibilities) => {
    if (!questionnaireCriteria) return;

    // Create updated criteria with new candidate responsibilities
    const updatedCriteria = {
      ...questionnaireCriteria,
      candidateResponsibilities: {
        ...questionnaireCriteria.candidateResponsibilities,
        items: newResponsibilities.map(responsibilityItem => {
          // Check if this responsibility already exists in our current criteria
          const existingResponsibility = questionnaireCriteria.candidateResponsibilities?.items?.find(
            item => item.responsibility === responsibilityItem.title
          );
          
          if (existingResponsibility) {
            // Keep existing responsibility with all its properties
            return existingResponsibility;
          } else {
            // Create new responsibility entry with candidateResponsibilities specific structure
            return {
              responsibility: responsibilityItem.title,
              rationale: responsibilityItem.subtitle || ""
            };
          }
        })
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle responsibilities change
  const handleResponsibilitiesChange = (newResponsibilities) => {
    setResponsibilities(newResponsibilities);
    updateCandidateResponsibilitiesCriteria(newResponsibilities);
  };

  return (
    <InputList
      items={responsibilities}
      onItemsChange={handleResponsibilitiesChange}
      label={label}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
    />
  );
};

export default IL_CandidateResponsibilities;
